import { FaHandHoldingHeart } from "react-icons/fa";
import { useSelector } from 'react-redux'
import { RootState } from '../../state/store'
import { CountryLeaderListView } from "../CountryLeaderListView";


export default function DashbardFoodiCountries() {

  const { filteredStats } = useSelector((state:RootState) => state.dashboard);

  return (
    <div className="h-full w-full">
            <CountryLeaderListView 
              title={"Total donation"}
              stats={[]}
              leadersInfo={filteredStats.leaderboard}
		      styles="bg-primary-50/80 dark:bg-primary-100/20"
          icon={<FaHandHoldingHeart className="text-lg text-primary-100"/>}
             
      />
    </div>
  )
}
